import { supabase } from '@/integrations/supabase/client';
import { StarterRecipe } from './starterRecipeAdminService';

/**
 * Public service for fetching active starter recipes and copying them to user's collection
 */
export const starterRecipeService = {
  /**
   * Fetch all active starter recipes for display to users
   */
  async getActiveStarterRecipes(): Promise<StarterRecipe[]> {
    console.log('Fetching active starter recipes...');
    
    const { data, error } = await supabase
      .from('starter_recipes')
      .select('*')
      .eq('is_active', true)
      .order('display_order', { ascending: true });

    if (error) {
      console.error('Error fetching active starter recipes:', error);
      throw new Error(`Failed to fetch starter recipes: ${error.message}`);
    }

    console.log('Fetched active starter recipes:', data?.length || 0);
    // Cast to StarterRecipe[] as the DB types use Json for structured fields
    return (data || []) as unknown as StarterRecipe[];
  },

  /**
   * Copy a starter recipe to the user's personal collection
   */
  async copyToCollection(starterRecipe: StarterRecipe, userId: string): Promise<string> {
    console.log('Copying starter recipe to collection:', starterRecipe.title);

    const { data, error } = await supabase
      .from('recipes')
      .insert({
        user_id: userId,
        title: starterRecipe.title,
        description: starterRecipe.description,
        ingredients: starterRecipe.ingredients,
        instructions: starterRecipe.instructions,
        prep_time: starterRecipe.prep_time,
        cook_time: starterRecipe.cook_time,
        total_time: starterRecipe.total_time,
        servings: starterRecipe.servings,
        source_url: starterRecipe.source_url,
        image_url: starterRecipe.image_url,
        storage_image_url: starterRecipe.storage_image_url,
        storage_image_path: starterRecipe.storage_image_path,
        tags: starterRecipe.tags,
        structured_ingredients_metric: starterRecipe.structured_ingredients_metric,
        structured_ingredients_imperial: starterRecipe.structured_ingredients_imperial,
        imperial_version: starterRecipe.imperial_version,
        metric_version: starterRecipe.metric_version,
        base_measurement_system: starterRecipe.base_measurement_system,
        is_quick_recipe: false,
        suggestion_id: `starter:${starterRecipe.id}`, // Track source starter recipe
      })
      .select('id')
      .single();

    if (error) {
      console.error('Error copying starter recipe:', error);
      throw new Error(`Failed to add recipe to collection: ${error.message}`);
    }

    console.log('Successfully copied starter recipe, new ID:', data.id);
    return data.id;
  }
};
